"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryDetailRequest = void 0;
var QueryDetailRequest = /** @class */ (function () {
    function QueryDetailRequest() {
        this.lectureNo = '1';
    }
    return QueryDetailRequest;
}());
exports.QueryDetailRequest = QueryDetailRequest;
;
//# sourceMappingURL=queryDetail.request.js.map